import { Navigate, Route, Routes } from 'react-router-dom'
import { LogHome } from './Home'

export const Log = () => {
    return (
        <Routes>
            <Route path="/" element={<LogHome />} />
            <Route path="*" element={<Navigate to="/system/log" />} />
        </Routes>
    )
}

export default Log
